import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
// import { useSelector, useDispatch } from "react-redux";
import {
  fetchCompanyData,
  selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import {
  fetchInstituteData,
  selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";
import {
  fetchDesignation,
  selectDesignation,
} from "../../redux/actions/designationAction";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
// import { fetchDesignation, selectDesignation } from '../../redux/actions/designationAction';
import {
  fetchOrganizationData,
  selectOrgsTypes,
} from "../../redux/actions/getOrgTypesAction";
import { useParams } from "react-router-dom";
// import { fetchInstituteData, selectGetInstitute } from '../../redux/actions/getInstitutesAction';
// import { fetchCompanyData, selectGetCompanies } from '../../redux/actions/getCompaniesAction';

function UpdateCandidatebyInstitute({ }) {
  const sessionId = localStorage.getItem("sessionId");
  const { CandidateId } = useParams();
  //   console.log("CandidateId", CandidateId);

  // ...............................PROFILE Start.......................................
  const [displays, setDisplays] = useState(false);
  const [headLine, setHeadLine] = useState("");
  const [website, setWebsite] = useState("");
  const [about, setAbout] = useState("");
  const [curretactive, setCurretactive] = useState("");
  const [orgType, setOrgType] = useState("");
  const [candidate, setCandidate] = useState("");
  const [currentlyActiveAs, setCurrentlyActiveAs] = useState("");
  const [selectedgetallId, setOrganizationType] = useState("");

  // ...............................Designation Dropdown.......................................

  const Profile = async () => {
    setDisplays(true);

    if (!curretactive || !orgType) {
      toast.error("Please fill in all required fields.");
      return;
    }

    if (orgType === "1" && !instituteId && !headLine && !website && !about) {
      toast.error("Please select an Institution.");
      return;
    } else if (orgType !== "1") {
      if (!companyId && !designationId && !headLine && !website && !about) {
        toast.error("Please fill all required fields.");
        return;
      }
    }

    let body = {
      sessionId: sessionId,
      currentlyActiveAs: curretactive,
      orgType: orgType,
      instnCnddtID: CandidateId,
    };

    if (orgType === 1) {
      body.insttnId = selectedinstituteId;
      body.compId = null;
      body.dsgntnId = null;
      body.headLine = headLine;
      body.about = about;
      body.website = website;
    } else {
      body.compId = selectedcompaniesId;
      body.dsgntnId = designationId;
      body.headLine = headLine;
      body.about = about;
      body.website = website;
    }

    // console.log("body", body);
    try {
      const res = await axios.post("/CandidateData/UpdateByInstitute", body);
      console.log("xnab :", res);

      // if (res.status === 200) {
      toast.success("Update Candidate Successfully");
      // }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  //   console.log("orgType", orgType);

  //   ........................add candidate data end  ...........................

  const dispatch = useDispatch();

  const [designationSearch, setDesignationSearch] = useState("");
  const [designationId, setDesignationId] = useState(null);
  const { designationList, selectedDesignationId } = useSelector(
    (state) => state.designation
  );

  useEffect(() => {
    dispatch(fetchDesignation());
  }, [dispatch]);

  const handleDesignation = (selectedOption) => {
    if (selectedOption) {
      setDesignationId(selectedOption.value);
    }
  };
  // ...............................Designation Dropdown.......................................

  // ...............................organization Dropdown.......................................
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [orgTypeLabel, setOrgTypeLabel] = useState("");
  const { orgstypesList, selectedorgstypesId } = useSelector(
    (state) => state.getorgstypes
  );
  // console.log('organization',orgstypesList,selectedorgstypesId);

  useEffect(() => {
    dispatch(fetchOrganizationData());
  }, [dispatch]);

  const handleOrganization = (selectedOption) => {
    if (selectedOption) {
      dispatch(selectOrgsTypes(selectedOption.value));
      setOrgTypeLabel(selectedOption.label);
    }
  };
  // ...............................organization Dropdown.......................................

  // ...............................Institute Dropdown.......................................
  const [instituteSearch, setInstituteSearch] = useState("");
  const [instituteId, setInstituteId] = useState(null);
  const { getinstituteList, selectedinstituteId } = useSelector(
    (state) => state.institute
  );
  // console.log('Institute',getinstituteList,selectedinstituteId);

  useEffect(() => {
    dispatch(fetchInstituteData());
  }, [dispatch]);

  const handleInstitute = (selectedOption) => {
    if (selectedOption) {
      setInstituteId(selectedOption.value);

      // dispatch(selectGetInstitute(selectedOption.value));
    }
  };
  // ...............................Institute Dropdown.......................................


  // ...............................Company Dropdown.......................................
  const [companySearch, setCompanySearch] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const { getcompaniesList, selectedcompaniesId } = useSelector(
    (state) => state.getcompanies
  );
  // console.log('companies',getcompaniesList,selectedcompaniesId);

  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleCompany = (selectedOption) => {
    if (selectedOption) {
      setCompanyId(selectedOption.value);
      // dispatch(selectGetCompanies(selectedOption.value));
    }
  };
  // ...............................company Dropdown.......................................

  return (
    // Prifile setting...................START.........................

    <div className="main-container settings mb-5 update-candid">
      <div className="content-wrapper">
        <div className="title delete-title ">
          <h1>
            {" "}
            <span className="orange-box"></span> Update Candidate By Institute
          </h1>
        </div>

        <div className="card delete-card  ">
          <div className="post-job-details-form Edit-Card-details-form">
            <div className="post-form-row">
              <div className="post-form-group">
                <label htmlFor="category">Currently Active</label>
                <select
                  id="currentactive"
                  className="form-control"
                  placeholder="value"
                  required
                  onChange={(e) => setCurretactive(e.target.value)}
                  value={curretactive}
                  invalid={displays && curretactive === ""}
                >
                  <option value="">Select Option</option>
                  <option value="1">Student</option>
                  <option value="2">Professional</option>
                </select>
                {displays && !curretactive ? (
                  <span className="error_msg_lbl text-red">
                    Enter Currently Active
                  </span>
                ) : null}
              </div>

              <div className="post-form-group">
                <label htmlFor="tag">Organization Type</label>
                <select
                  className="form-control"
                  onChange={(e) => setOrgType(e.target.value)}
                  value={orgType}
                  id="Orgtype"
                  placeholder="Organization Type"
                  required
                  styles={customStyles}
                  invalid={displays && orgType === ""}
                >
                  <option value="Default Value">Select here</option>
                  <option value="1">Institution</option>
                  <option value="2">Company</option>
                </select>

                {displays && !orgType ? (
                  <span className="error_msg_lbl text-red">
                    Enter Organization Type
                  </span>
                ) : null}
              </div>
            </div>

            {/* Conditionally render additional fields based on organization type */}
            {orgType && (
              <div>
                {orgType === "1" ? (
                  <>
                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="jobApplyType">Institution</label>
                        <ReactSelect
                          options={getinstituteList}
                          onChange={handleInstitute}
                          value={
                            getinstituteList.find(
                              (option) => option.value === instituteId
                            ) || null
                          }
                          placeholder="Select Institute Type"
                          styles={customStyles}
                          classNamePrefix="react-select"
                          className="form-control"
                          onInputChange={(inputValue) =>
                            setInstituteSearch(inputValue)
                          }
                          invalid={displays && instituteSearch === ""}
                        />
                        {displays && !instituteId ? (
                          <span className="error_msg_lbl text-red">
                            Enter Institution
                          </span>
                        ) : null}
                      </div>
                      <div className="post-form-group">
                        <label htmlFor="minSalary">HeadLine</label>
                        <input
                          type="text"
                          id="minSalary"
                          placeholder="HeadLine"
                          className="form-control Normal-Input-Fill"
                          required
                          onChange={(e) => setHeadLine(e.target.value)}
                          value={headLine}
                          invalid={displays && headLine === ""}
                        />
                        {displays && !headLine ? (
                          <span className="error_msg_lbl text-red">
                            Enter HeadLine
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="experience">Website</label>
                        <input
                          type="text"
                          id="experience"
                          placeholder="Website"
                          // className="form-control  Dark-Input-from-group"
                          onChange={(e) => setWebsite(e.target.value)}
                          value={website}
                          invalid={displays && website === ""}
                          className="form-control Normal-Input-Fill"
                        />
                        {displays && !website ? (
                          <span className="error_msg_lbl text-red">
                            Enter Website
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="maxSalary">About</label>
                        <textarea
                          type="text"
                          id="maxSalary"
                          placeholder="About"
                          onChange={(e) => setAbout(e.target.value)}
                          value={about}
                          invalid={displays && about === ""}
                        />
                        {displays && !about ? (
                          <span className="error_msg_lbl text-red">
                            Enter About
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="gender">Company</label>
                        <ReactSelect
                          options={getcompaniesList}
                          onChange={handleCompany}
                          value={
                            getcompaniesList.find(
                              (option) => option.value === companyId
                            ) || null
                          }
                          placeholder="Select Company Type"
                          styles={customStyles}
                          classNamePrefix="react-select"
                          className="form-control"
                          onInputChange={(inputValue) =>
                            setCompanySearch(inputValue)
                          }
                          invalid={displays && companySearch === ""}
                        />
                        {displays && !companyId ? (
                          <span className="error_msg_lbl text-red">
                            Enter Company
                          </span>
                        ) : null}
                      </div>

                      <div className="post-form-group">
                        <label htmlFor="externalUrl">Designation</label>
                        <ReactSelect
                          options={designationList}
                          onChange={handleDesignation}
                          value={
                            designationList.find(
                              (option) => option.value === designationId
                            ) || null
                          }
                          placeholder="Select Designation Type"
                          styles={customStyles}
                          classNamePrefix="react-select"
                          className="form-control"
                          onInputChange={(inputValue) =>
                            setDesignationSearch(inputValue)
                          }
                          invalid={displays && designationSearch === ""}
                        />
                        {displays && !designationId ? (
                          <span className="error_msg_lbl text-red">
                            Enter Designation
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="minSalary">HeadLine</label>
                        <input
                          type="text"
                          id="minSalary"
                          placeholder="HeadLine"
                          required
                          onChange={(e) => setHeadLine(e.target.value)}
                          value={headLine}
                          className="form-control Normal-Input-Fill"
                          invalid={displays && headLine === ""}
                        />
                        {displays && !headLine ? (
                          <span className="error_msg_lbl text-red">
                            Enter HeadLine
                          </span>
                        ) : null}
                      </div>

                      <div className="post-form-group">
                        <label htmlFor="about">
                          Place Details{" "}
                          <span style={{ color: "red" }} className="ms-2">
                            *
                          </span>
                        </label>
                        <input
                          type="text"
                          // value={placeDetails}
                          // onChange={(e) => setPlaceDetails(e.target.value)}
                          placeholder="Enter place details"
                          className="form-control Normal-Input-Fill"
                        />
                      </div>

                      <div className="post-form-group">
                        <label htmlFor="experience">Website</label>
                        <input
                          type="text"
                          id="experience"
                          placeholder="Website"
                          onChange={(e) => setWebsite(e.target.value)}
                          value={website}
                          className="form-control Normal-Input-Fill"
                          invalid={displays && website === ""}
                        />
                        {displays && !website ? (
                          <span className="error_msg_lbl text-red">
                            Enter Website
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="maxSalary">About</label>
                        <textarea
                          type="text"
                          id="maxSalary"
                          placeholder="About"
                          onChange={(e) => setAbout(e.target.value)}
                          value={about}
                          invalid={displays && about === ""}
                        />
                        {displays && !about ? (
                          <span className="error_msg_lbl text-red">
                            Enter About
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="avatar-upload-container">
              <button className="save-button" onClick={(e) => Profile(e)}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateCandidatebyInstitute;
